import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-accepted-inquiry",
  "use": "notification-accepted-inquiry-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"notification-accepted-inquiry\">\n  <path fill-rule=\"evenodd\" d=\"M577.167,130.667a5.665,5.665,0,1,0-8.677,4.79A8.662,8.662,0,0,0,563,142h1.444a7.244,7.244,0,0,1,7.059-5.667A5.672,5.672,0,0,0,577.167,130.667Zm-5.664,4.25a4.25,4.25,0,1,1,4.248-4.25A4.255,4.255,0,0,1,571.5,134.917Zm6.373,3.541v-2.125h-1.417v2.125h-2.124v1.417h2.124V142h1.417v-2.125H580v-1.417h-2.124Z\" transform=\"translate(-563 -125)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-accepted-inquiry.svg
// module id = null
// module chunks = 